if (!customElements.get('related-product-card')) {
  customElements.define(
    'related-product-card',
    class RelatedProductCard extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.image = this.querySelector('[data-related-image]');
        this.variantInput = this.querySelector('[data-related-variant-id]');
        this.compareEl = this.querySelector('[data-related-compare]');
        this.priceEl = this.querySelector('[data-related-price]');
        this.atc = this.querySelector('[data-related-atc]');
        this.atcLabel = this.atc ? this.atc.querySelector('[data-related-atc-label]') : null;
        this.swatches = this.querySelectorAll('[data-related-swatch]');

        this.addEventListener('click', this.onClick.bind(this), true);
      }

      onClick(event) {
        const swatch = event.target.closest('[data-related-swatch]');
        if (swatch && this.contains(swatch)) {
          event.preventDefault();
          event.stopPropagation();
          this.selectSwatch(swatch);
          return;
        }

        if (!this.atc || this.atc.disabled) return;

        const clickedAtc = event.target.closest('[data-related-atc]');
        const overAtc = this.isPointerOver(event, this.atc);
        if (!clickedAtc && !overAtc) return;

        event.preventDefault();
        event.stopPropagation();
        this.addToCart();
      }

      isPointerOver(event, element) {
        if (!element) return false;
        const style = window.getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden' || style.pointerEvents === 'none') {
          return false;
        }
        const rect = element.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return false;
        return (
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom
        );
      }

      getSelectedVariantId() {
        if (this.variantInput && this.variantInput.value) return this.variantInput.value;
        const selected = this.querySelector('[data-related-swatch].is-selected');
        if (selected && selected.dataset.variantId) return selected.dataset.variantId;
        return this.dataset.variantId || '';
      }

      selectSwatch(swatch) {
        this.swatches.forEach((item) => {
          item.classList.toggle('is-selected', item === swatch);
          item.setAttribute('aria-pressed', item === swatch ? 'true' : 'false');
        });

        const variantId = swatch.dataset.variantId;
        const image = swatch.dataset.image;
        const price = swatch.dataset.price;
        const compare = swatch.dataset.compare;
        const available = swatch.dataset.available !== 'false';

        if (variantId) {
          this.dataset.variantId = variantId;
        }

        if (this.variantInput && variantId) {
          this.variantInput.value = variantId;
        }

        if (this.image && image) {
          this.image.src = image;
          this.image.removeAttribute('srcset');
        }

        if (this.priceEl && price) {
          this.priceEl.textContent = price;
        }

        if (this.compareEl) {
          if (compare) {
            this.compareEl.textContent = compare;
            this.compareEl.hidden = false;
          } else {
            this.compareEl.textContent = '';
            this.compareEl.hidden = true;
          }
        }

        if (this.atc) {
          this.atc.disabled = !available;
          if (this.atcLabel) {
            this.atcLabel.textContent = available
              ? this.atc.dataset.addLabel || 'ADD TO CART'
              : this.atc.dataset.soldLabel || 'SOLD OUT';
          }
        }
      }

      addToCart() {
        if (!this.atc || this.atc.disabled || this.atc.getAttribute('aria-disabled') === 'true') return;
        const variantId = this.getSelectedVariantId();
        if (!variantId) return;

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

        this.atc.classList.add('is-loading');
        this.atc.setAttribute('aria-disabled', 'true');

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(document.activeElement);
          }
        }

        fetch(addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'related-product-card',
                productVariantId: variantId,
                cartData: response,
              });
            }
          })
          .catch(() => {})
          .finally(() => {
            this.atc.classList.remove('is-loading');
            this.atc.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
